
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    export class MaterialOutItemsGrid extends Serenity.EntityGrid<MaterialOutItemsRow, any> {
        protected getColumnsKey() { return 'Sales.MaterialOutItems'; }
        protected getDialogType() { return MaterialOutItemsDialog; }
        protected getIdProperty() { return MaterialOutItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialOutItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialOutItemsRow.localTextPrefix; }
        protected getService() { return MaterialOutItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}